(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-product-pair"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', async function (event) {
    const form = event.target.closest('[data-cc-pair-form]');
    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-cc-pair-status]');
    const items = Array.from(form.querySelectorAll('[data-cc-pair-id]')).map(function (input) {
      return { id: Number(input.value), quantity: 1 };
    });

    button.disabled = true;
    status.textContent = '';

    try {
      const response = await fetch(form.action + '.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: items })
      });

      if (!response.ok) throw new Error('Cart add failed');
      window.location.assign(form.dataset.cartUrl);
    } catch (error) {
      status.textContent = form.dataset.error;
      button.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cc-sticky-buy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-sticky-buy')) {
    customElements.define('cc-sticky-buy', class extends HTMLElement {
      connectedCallback() {
        this.source = document.getElementById(this.dataset.buttonId);
        this.form = document.getElementById(this.dataset.formId);
        this.action = this.querySelector('button');
        if (!this.source || !this.form) return;
        this.onClick = () => {
          if (this.source.disabled) return;
          this.form.requestSubmit(this.source);
        };
        this.action.addEventListener('click', this.onClick);
        this.sync = () => {
          this.action.disabled = this.source.disabled || this.source.getAttribute('aria-disabled') === 'true';
          this.action.textContent = this.source.querySelector('span')?.textContent.trim() || this.source.textContent.trim();
        };
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.source,{attributes:true,childList:true,subtree:true,characterData:true});
        this.visibility = new IntersectionObserver(entries => {
          this.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
        },{threshold:0});
        this.visibility.observe(this.source);
        this.sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect(); this.visibility?.disconnect();
        this.action?.removeEventListener('click',this.onClick);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cc-sticky-checkout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-sticky-checkout')) {
    customElements.define('cc-sticky-checkout', class extends HTMLElement {
      connectedCallback() {
        this.source = document.getElementById(this.dataset.buttonId);
        this.form = this.source?.form;
        this.action = this.querySelector('button');
        if (!this.source || !this.form || !this.action) return;
        this.sourceVisible = false;
        this.updateVisibility = () => {
          const unavailable = this.source.disabled || this.source.getAttribute('aria-disabled') === 'true';
          this.hidden = unavailable || this.sourceVisible;
        };
        this.onClick = () => {
          if (this.source.disabled || this.source.getAttribute('aria-disabled') === 'true') return;
          this.form.requestSubmit(this.source);
        };
        this.action.addEventListener('click', this.onClick);
        this.sync = () => {
          const unavailable = this.source.disabled || this.source.getAttribute('aria-disabled') === 'true';
          this.action.disabled = unavailable;
          this.action.textContent = this.source.textContent.trim();
          this.updateVisibility();
        };
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.source,{attributes:true,childList:true,subtree:true,characterData:true});
        this.visibility = new IntersectionObserver(entries => {
          this.sourceVisible = entries[0].isIntersecting;
          this.updateVisibility();
        },{threshold:0});
        this.visibility.observe(this.source);
        this.sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.visibility?.disconnect();
        this.action?.removeEventListener('click',this.onClick);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
